import { useEffect, useState } from 'react'
import { api } from '../api/client.ts'
import { Avatar } from './Avatar.tsx'

/**
 * КТО ПРОЧИТАЛ
 *
 * В переписке один на один хватает галочек. В группе из пятерых галочка
 * отвечает на вопрос «прочитали ли все», но спрашивают обычно другое:
 * «кто ещё не видел». Поэтому здесь список, а не число.
 *
 * Прочитавшим считается тот, кто дочитал дальше этого сообщения.
 * Отдельная отметка на каждое сообщение означала бы запись в базу
 * на каждую прокрутку пальцем.
 */

type Person = { id: string; displayName: string; avatarUrl: string | null }

export function ReadBy({ messageId, onClose }: { messageId: string; onClose: () => void }) {
  const [readers, setReaders] = useState<Person[] | null>(null)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    api<{ readers: Person[]; total: number }>(`/api/messages/${messageId}/readers`)
      .then((data) => {
        setReaders(data.readers)
        setTotal(data.total)
      })
      .catch(() => setReaders([]))
  }, [messageId])

  return (
    <div className="sheet" onClick={onClose}>
      <div className="sheet-body" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-head">
          <h2>
            {readers === null
              ? 'Кто прочитал'
              : `Прочитали ${readers.length} из ${total}`}
          </h2>
          <button className="icon-btn" onClick={onClose} aria-label="Закрыть">
            ✕
          </button>
        </div>

        {readers === null && (
          <div className="center-screen" style={{ height: 80 }}>
            <div className="spinner" />
          </div>
        )}

        {readers?.length === 0 && <p className="comments-empty">Пока никто не прочитал</p>}

        <div className="member-list">
          {readers?.map((person) => (
            <div key={person.id} className="member-row">
              <Avatar id={person.id} name={person.displayName} url={person.avatarUrl} size={36} />
              <div className="member-text">
                <div className="member-name">{person.displayName}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
